import React, { useState, useEffect, useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';
import { AuthContext } from '../Login/AuthContext';
import logo from '../../assets/logo.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const { isAuthenticated, user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  // Handle scroll event to add background to navbar on scroll
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close the mobile menu when changing routes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  // Prevent body scrolling when mobile menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  // Calculate total tokens from user data
  const getUserTotalTokens = () => {
    if (!user) return 0;
    return (user.tokens_ltd || 0) + (user.tokens_subscription || 0);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <>
      <header className={`navbar ${isScrolled ? 'navbar--scrolled' : ''}`}>
        <div className="navbar__container">
          {/* Logo */}
          <Link to="/" className="navbar__logo">
            <span className="navbar__logo-text">AiVatar</span>
          </Link>
          
          {/* Navigation Links - Desktop */}
          <nav className={`navbar__navigation ${isMenuOpen ? 'navbar__navigation--active' : ''}`}>
            <ul className="navbar__menu">
              <li className="navbar__menu-item">
                <Link to="/" className={`navbar__menu-link ${location.pathname === '/' ? 'active' : ''}`}>
                  Home
                </Link>
              </li>
              {isAuthenticated && (
                <li className="navbar__menu-item">
                  <Link to="/app" className={`navbar__menu-link ${location.pathname === '/app' ? 'active' : ''}`}>
                    Create Avatar
                  </Link>
                </li>
              )}
       
              <li className="navbar__menu-item">
                <Link to="/pricing" className={`navbar__menu-link ${location.pathname === '/pricing' ? 'active' : ''}`}>
                  Pricing
                </Link>
              </li>
            </ul>
            
            {/* Mobile-only user section */}
            <div className="navbar__mobile-auth">
              {isAuthenticated ? (
                <>
                  <div className="navbar__user-email">{user?.email}</div>
                  <div className="navbar__mobile-actions">
                    <div className="navbar__tokens">
                      <span className="navbar__tokens-count">{getUserTotalTokens()}</span>
                      <span className="navbar__tokens-label">Tokens</span>
                    </div>
                    <button onClick={handleLogout} className="btn btn-outline navbar__logout-btn">
                      Logout
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <Link to="/login" className="btn btn-outline navbar__mobile-login-btn">
                    Login
                  </Link>
                  <Link to="/signup" className="btn navbar__mobile-signup-btn">
                    Sign Up
                  </Link>
                </>
              )}
            </div>
          </nav>
          
          {/* Auth section - Desktop */}
          <div className="navbar__auth">
            {isAuthenticated ? (
              <>
                <div className="navbar__user-section">
                  <div className="navbar__user-email">{user?.email}</div>
                  <div className="navbar__tokens">
                    <span className="navbar__tokens-count">{getUserTotalTokens()}</span>
                    <span className="navbar__tokens-label">Tokens</span>
                  </div>
                </div>
                <button onClick={handleLogout} className="btn btn-outline navbar__logout-btn">
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="btn btn-outline navbar__login-btn">
                  Login
                </Link>
                <Link to="/signup" className="btn btn-primary navbar__signup-btn">
                  Sign Up
                </Link>
              </>
            )}
          </div>
          
          {/* Mobile menu toggle */}
          <button 
            className={`navbar__mobile-toggle ${isMenuOpen ? 'navbar__mobile-toggle--active' : ''}`} 
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span className="navbar__mobile-toggle-bar"></span>
            <span className="navbar__mobile-toggle-bar"></span>
            <span className="navbar__mobile-toggle-bar"></span>
          </button>
        </div>
      </header>
      
      {/* Overlay for mobile menu */}
      <div 
        className={`navbar__overlay ${isMenuOpen ? 'navbar__overlay--active' : ''}`}
        onClick={toggleMenu}
      ></div>
    </>
  );
};

export default Navbar; 